import { render } from "./HeaderCabinetsAndEmployees.vue?vue&type=template&id=0074d964&scoped=true"
import script from "./HeaderCabinetsAndEmployees.vue?vue&type=script&lang=js"
export * from "./HeaderCabinetsAndEmployees.vue?vue&type=script&lang=js"

import "./HeaderCabinetsAndEmployees.vue?vue&type=style&index=0&id=0074d964&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0074d964"]])

export default __exports__